/**
 * Height conversion utilities
 * Handles conversion between metric (cm) and imperial (feet/inches)
 */

export const FEET_TO_CM = 30.48;
export const INCHES_TO_CM = 2.54;
export const CM_TO_INCHES = 1 / INCHES_TO_CM;

/**
 * Convert feet and inches to centimeters
 */
export function convertFeetInchesToCm(feet: number, inches: number): number {
  return feet * FEET_TO_CM + inches * INCHES_TO_CM;
}

/**
 * Convert centimeters to feet and inches
 */
export function convertCmToFeetInches(cm: number): {
  feet: number;
  inches: number;
} {
  const totalInches = cm * CM_TO_INCHES;
  const feet = Math.floor(totalInches / 12);
  const inches = Math.round(totalInches % 12);
  return { feet, inches };
}
